<ion-header no-shadow no-border>
  <ion-toolbar>
    <ion-title>Resultados</ion-title>
    <ion-buttons slot="start">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar class="gray">
    <div class="results-header">
      <p hidden>Ruta: {{ stop?.id }}</p>
      <p>Parada: {{ stop?.name }}</p>
    </div>
    <div class="results-header">
      <p>Día: {{ day }}</p>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p *ngIf="!schedules || schedules.length === 0">No hay corridas para la fecha seleccionada.</p>
  <div
    class="result"
    [class.unavailable]="item.availability === 0"
    (click)="item.availability && select(item)"
    *ngFor="let item of schedules"
  >
    <div class="result-content">
      <div class="result-title">
        <p class="ion-float-left">{{ item.starts_at | slice: 0:5 }}</p>
      </div>
      <div class="result-body">
        <p hidden>Autobús {{ item.bus }}</p>
        <p>Disponibilidad: {{ item.availability < 0 ? 0 : item.availability }}</p>
      </div>
    </div>
    <div class="arrow">
      <ion-icon name="ios-arrow-forward"></ion-icon>
    </div>
  </div>
</ion-content>
